import React from "react";
import { Container } from "./style";

const Announcement = () => {
  return <Container>Super Deal! Free Ground Shipping Over $15000</Container>;
};

export default Announcement;
